import type { DeepPartial } from '@luna/utils-ts';

import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsHUFeatureConfig: DeepPartial<ProductSettings> = {
    showAccountInfo: true,
    showFeesIncludedSetting: true,
};
